import {
  Component,
  Prop,
  Event,
  EventEmitter,
  h
} from '@stencil/core';
import ReportHelpers from '../internal/log-modal/report-codes-helper';
import { Trouble } from './area-interface';
import moment from 'moment';
import has from 'lodash-es/has';
import filter from 'lodash-es/filter';
import forOwn from 'lodash-es/forOwn';
import sortBy from 'lodash-es/sortBy';
import { getEventMessage } from '@larva.io/report-definitions';
import { config } from '../../global/config';
import { Color } from '../../interface';

@Component({
  tag: 'lar-area-troubles',
  styleUrl: 'area-troubles.scss',
  shadow: true
})
export class AreaTroubleList {
  private config = config;

  @Prop() header: any;
  @Prop() modal: HTMLLarModalElement;
  @Prop() troubles: string;
  /**
   * The color to use from your application's color palette for inputs
   */
  @Prop({ mutable: true }) colorInputs?: Color;

  @Event() output!: EventEmitter<any>;

  private acktrouble(trouble: any) {
    this.output.emit({ command: 'ack_trouble', trouble_id: trouble.id });
  }

  render() {
    const troubleList = JSON.parse(this.troubles) as Trouble[];
    if (troubleList.length === 0) {
      this.modal.dismiss();
      return;
    }
    const troubles: any[] = [];
    const formatDateTime = this.config.get('formatDateTime', 'DD.MM.YYYY HH:mm');
    const zoneTroubles = filter(troubleList, t => has(t, 'zone') && t.type_id !== 0 && t.type_id !== 3);
    const alarms = filter(troubleList, t => t.type_id === 0 || t.type_id === 3);
    const systemTroubles = filter(troubleList, t => !has(t, 'zone'));
    const groupedTroubles = {
      'area.alarmsTroubles': alarms,
      'area.systemTroubles': systemTroubles,
      'area.zoneTroubles': zoneTroubles,
    };
    forOwn(groupedTroubles, (groupTroubles, group) => {
      if (groupTroubles.length > 0) {
        troubles.push(
          <lar-list-header>
            <lar-translate t={group} />
          </lar-list-header>
        );
      }
      groupTroubles = sortBy(groupTroubles, 'created');
      groupTroubles.forEach(trouble => {
        let text = <lar-translate t={'area.trouble_code_messages.' + trouble.type_id} fallback={trouble.text} />
        // tslint:disable-next-line: strict-boolean-conditions
        if ((trouble.type_id === 0 || trouble.type_id === 3) && trouble.zone && trouble.zone.reportcode && ReportHelpers.isSecurityEvent(trouble.zone.reportcode)) {
          const message = getEventMessage(trouble.zone.reportcode);
          text = <lar-translate t={'log_entries.' + trouble.zone.reportcode} fallback={message} />
        }
        troubles.push(
          <lar-list-item>
            <div slot="start" class="circle">
              {trouble.zone
                &&
                <lar-icon icon={trouble.zone.type} color={group === 'area.alarmsTroubles'?'danger':'warning'} />
              }
              {!trouble.zone
                &&
                <lar-icon icon="device" color="warning" />
              }
            </div>
            <div>
              <h4>
                {trouble.zone
                  &&
                  <span><lar-translate t={trouble.zone.name}></lar-translate> - </span>
                }
                {text}
              </h4>
              <small>{moment(trouble.created).format(formatDateTime)}</small>
              {trouble.resolved !== null && trouble.resolved !== undefined
                &&
                <small><br />{moment(trouble.resolved).format(formatDateTime)}&nbsp;<lar-badge color="success"><lar-translate t={'log.resolved'} /></lar-badge></small>
              }
              {trouble.overridden &&
                <span>&nbsp;<lar-badge color="danger"><lar-translate t={'area.zone_state.bypassed'} /></lar-badge></span>
              }
            </div>
            <div slot="end">
            {trouble.resolved !== null && trouble.resolved !== undefined &&
              <lar-button size="small" onClick={() => { this.acktrouble(trouble); }} outline color={this.colorInputs}><lar-translate t="area.clear" /></lar-button>
            }
            </div>
          </lar-list-item>
        );
      });
    });
    return <lar-list class="trouble-list">{troubles}</lar-list>;
  }
}
